import { render, staticRenderFns } from "./DataRuleForm.vue?vue&type=template&id=75d94f83"
import script from "./DataRuleForm.vue?vue&type=script&lang=js"
export * from "./DataRuleForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75d94f83')) {
      api.createRecord('75d94f83', component.options)
    } else {
      api.reload('75d94f83', component.options)
    }
    module.hot.accept("./DataRuleForm.vue?vue&type=template&id=75d94f83", function () {
      api.rerender('75d94f83', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/form/DataRuleForm.vue"
export default component.exports